"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProjectFunnelResultByChunks = void 0;
const ICCanisterUtils_1 = require("src/hello_assets/src/util/ICCanisterUtils");
const async_1 = __importDefault(require("async"));
const lodash_1 = __importDefault(require("lodash"));
const ArrayCalculationsFacade_1 = require("src/hello_assets/src/util/ArrayCalculationsFacade");
const AnalyticsStoreRestApi_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/AnalyticsStoreRestApi");
const getProjectFunnelResultByChunks = async (actors, accessToken, lastNDays, returnEvents) => {
    return new Promise((resolve, reject) => {
        if (process.env.NODE_ENV === "development") {
            console.log("FunnelApiService.getProjectFunnelResultByChunks!!!! ", /* actor,*/ { lastNDays, returnEvents });
            // if (Math.random() > 0.5) {
            //     throw new Error("Random error: " + new Date().toUTCString())
            // }
        }
        const numberOfChunksByLastNDays = getNumberOfChunksByLastNDays(lastNDays);
        if (!!process.env.IS_TEST_SERVER) {
            console.log("getProjectFunnelResultByChunks numberOfChunksByLastNDays", { lastNDays, numberOfChunksByLastNDays });
        }
        const ranges = (0, ICCanisterUtils_1.splitPartitionsCountIntoChunks)(numberOfChunksByLastNDays, ICCanisterUtils_1.USERS_PARTITIONS_COUNT);
        const tasks = lodash_1.default.flatten(lodash_1.default.map(actors, (actor, actorIdx) => {
            return lodash_1.default.flatten(lodash_1.default.map(ranges, (range, rangeIdx) => {
                const cumulativeIdx = ranges.length * actorIdx + rangeIdx;
                return (callback) => {
                    (async () => {
                        try {
                            const result = await AnalyticsStoreRestApi_1.AnalyticsStoreRestApi.getProjectFunnelChunkDay(actor, accessToken, returnEvents, { last: lastNDays }, range);
                            const taskResult = { idx: cumulativeIdx, actorIndex: actorIdx, chunk: result };
                            callback(null, taskResult);
                        }
                        catch (e) {
                            callback(e);
                        }
                    })();
                };
            }));
        }));
        async_1.default.parallelLimit(tasks, 10, (err, results) => {
            if (!lodash_1.default.isNil(err)) {
                console.warn("getProjectFunnelResultByChunks promises failure: at least one of the chunks failed", err);
                resolve({ err: { "temporarilyUnavailable": null } });
            }
            else {
                if (process.env.NODE_ENV === "development") {
                    console.log("getProjectFunnelResultByChunks promises results", results);
                }
                try {
                    const tasksResult = results;
                    const thereAreErrors = lodash_1.default.some(tasksResult, (taskResult) => {
                        if ((taskResult === null || taskResult === void 0 ? void 0 : taskResult.chunk) == undefined) {
                            return true;
                        }
                        return (0, ICCanisterUtils_1.isICRequestErr)(taskResult.chunk);
                    });
                    if (thereAreErrors) {
                        console.warn("getProjectFunnelResultByChunks promises failure: there are backend errors", tasksResult);
                        resolve({ err: { "temporarilyUnavailable": null } });
                        return;
                    }
                    else {
                        //all chunk errors (by checking "isICRequestErr") made above. So here all variants are "#ok".
                        const funnelChartResultDataArray = lodash_1.default.compact(lodash_1.default.map(tasksResult, (taskResult) => {
                            if (taskResult != undefined && (0, ICCanisterUtils_1.isICRequestOk)(taskResult.chunk)) {
                                return {
                                    idx: taskResult.idx,
                                    actorIndex: taskResult.actorIndex,
                                    chunkData: taskResult.chunk.ok
                                };
                            }
                        }));
                        if (!!process.env.IS_TEST_SERVER) {
                            console.log("getProjectFunnelResultByChunks promises: lifecycleChartResultDataArray", funnelChartResultDataArray);
                        }
                        if (funnelChartResultDataArray.length > 0) {
                            const firstData = funnelChartResultDataArray[0].chunkData;
                            const numberOfSteps = lodash_1.default.size(firstData.overtime);
                            if (numberOfSteps > 0) {
                                const classic = Uint32Array.from(ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray(lodash_1.default.compact(lodash_1.default.map(funnelChartResultDataArray, v => Array.from(v.chunkData.classic)))));
                                const overtime = new Array(numberOfSteps).fill(new Uint32Array());
                                for (let currentStep = 0; currentStep < numberOfSteps; currentStep++) {
                                    overtime[currentStep] = Uint32Array.from(ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray(lodash_1.default.compact(lodash_1.default.map(funnelChartResultDataArray, v => Array.from(v.chunkData.overtime[currentStep])))));
                                }
                                const funnelResult = {
                                    ok: {
                                        classic: classic,
                                        overtime: overtime,
                                        intervalStartTimeSec: firstData.intervalStartTimeSec
                                    }
                                };
                                resolve(funnelResult);
                                return;
                            }
                        }
                        else {
                            console.warn("getProjectFunnelResultByChunks promises failure: no success results", tasksResult);
                            resolve({ err: { "temporarilyUnavailable": null } });
                            return;
                        }
                    }
                }
                catch (e) {
                    console.error("getProjectFunnelResultByChunks failed", e);
                    resolve({ err: { "temporarilyUnavailable": null } });
                    return;
                }
            }
        });
        // const result: GetProjectFunnelResult = await actor.getProjectFunnelChunkDay(accessToken, returnEvents, {last: lastNDays}, ranges[0])
        // return result
    });
};
exports.getProjectFunnelResultByChunks = getProjectFunnelResultByChunks;
const getNumberOfChunksByLastNDays = (lastNDays) => {
    if (lastNDays >= 180) {
        return 128;
    }
    if (lastNDays >= 90) {
        return 64;
    }
    if (lastNDays >= 60) {
        return 32;
    }
    if (lastNDays >= 30) {
        return 16;
    }
    if (lastNDays >= 15) {
        return 8;
    }
    return 2;
};
